<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-10 11:12:17
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-10 11:12:17
 * @FilePath: \vue-privilege-routing\src\pages\component\index.vue
-->
<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-09 16:33:19
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-09 16:33:25
 * @FilePath: \vue-privilege-routing\src\pages\system\index.vue
-->
<template>
    <div>
       <router-view></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    mounted() {

    }
}
</script>
